import {
  LEGAL_ENTITY_SUCCESS,
  LEGAL_ENTITY_FAILED,
  RESET_LEGAL_ENTITY,
  LOADING_LEGAL_ENTITY,
  NETWORK_ERROR_LEGAL_ENTITY,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetLegalEntity = () => {
  return { type: RESET_LEGAL_ENTITY };
};

const getLegalEntity = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_LEGAL_ENTITY });
  await partnerServices
    .post("addLegalEntity", userData, { headers: { AuthToken: authTokenIs } })

    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(legalEntitysuccess(res.data));
          //   history.push({ pathname: "/index/homepage" });
          break;
        default:
          dispatch(legalEntityfailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_LEGAL_ENTITY, payload: err });
    });
};

function legalEntitysuccess(data) {
  return {
    type: LEGAL_ENTITY_SUCCESS,
    payload: data,
  };
}

function legalEntityfailed(data) {
  return {
    type: LEGAL_ENTITY_FAILED,
    payload: data,
  };
}

export { resetLegalEntity, getLegalEntity };
